if (!customElements.get('sk-gift-form')) {
  const FIELDS = ['email', 'name', 'message'];

  class SiRecipientForm extends HTMLElement {
    connectedCallback() {

      const id = this.dataset.sectionId;

      this.checkbox = this.querySelector(`#Recipient-Checkbox-${id}`);
      this.control = this.querySelector(`#Recipient-Control-${id}`);
      if (!this.checkbox) return;

      this.inputs = {};
      FIELDS.forEach((field) => {
        this.inputs[field] = this.querySelector(`#Recipient-${field}-${id}`);
      });

      this.errorWrapper = this.querySelector('.buy-form__recipient-error-message-wrapper');
      this.errorList = this.errorWrapper?.querySelector('ul');
      this.errorHeading = this.errorWrapper?.querySelector('.error-message');
      this.defaultHeading = this.errorHeading?.innerText;

      this.variantId = this.dataset.productVariantId;

      this.checkbox.disabled = false;
      if (this.control) this.control.disabled = true;

      this.onChange = () => {
        if (!this.checkbox.checked) this.reset();
      };
      this.onCartAdded = (event) => {
        if (String(event.detail.product?.id) === this.variantId) this.uncheck();
      };
      this.onVariantChange = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.variantId = String(event.detail.variant?.id);
        }
      };
      this.onVariantError = (event) => {
        if (event.detail.source !== 'product-form') return;
        if (String(event.detail.productVariantId) !== this.variantId) return;
        this.showErrors(event.detail.errors);
      };

      this.addEventListener('change', this.onChange);
      document.addEventListener('cart:item-added', this.onCartAdded);
      document.addEventListener('product:variant-change', this.onVariantChange);
      document.addEventListener('product:variant-error', this.onVariantError);
    }

    disconnectedCallback() {

      document.removeEventListener('cart:item-added', this.onCartAdded);
      document.removeEventListener('product:variant-change', this.onVariantChange);
      document.removeEventListener('product:variant-error', this.onVariantError);
    }

    reset() {
      FIELDS.forEach((field) => {

        if (this.inputs[field]) this.inputs[field].value = '';
      });
      this.clearErrors();
    }

    uncheck() {
      if (!this.checkbox.checked) return;
      this.checkbox.checked = false;
      this.reset();
    }

    showErrors(errors) {
      this.clearErrors();
      if (!this.errorWrapper) return;

      this.errorWrapper.hidden = false;

      if (typeof errors !== 'object' || errors === null) {
        if (this.errorHeading) this.errorHeading.innerText = errors;
        return;
      }

      if (this.errorHeading) this.errorHeading.innerText = this.defaultHeading;

      Object.entries(errors).forEach(([field, problem]) => {
        const input = this.inputs[field];
        const slotId = `RecipientForm-${field}-error-${this.dataset.sectionId}`;
        const slot = this.querySelector(`#${slotId}`);
        const text = slot?.querySelector('.error-message');
        if (!text) return;

        const label = input?.getAttribute('placeholder') || field;
        const message = `${label} ${problem}`;

        text.innerText = `${message}.`;
        slot.classList.remove('hidden');

        this.errorList?.appendChild(this.errorLink(`#Recipient-${field}-${this.dataset.sectionId}`, message));

        if (!input) return;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', slotId);
      });
    }

    errorLink(href, message) {
      const item = document.createElement('li');
      item.className = 'error-message';

      const link = document.createElement('a');
      link.setAttribute('href', href);
      link.innerText = message;

      item.appendChild(link);
      return item;
    }

    clearErrors() {
      if (this.errorWrapper) this.errorWrapper.hidden = true;
      if (this.errorList) this.errorList.innerHTML = '';

      this.querySelectorAll('.recipient-fields .form__message').forEach((slot) => {
        slot.classList.add('hidden');
        const text = slot.querySelector('.error-message');
        if (text) text.innerText = '';
      });

      FIELDS.forEach((field) => {
        const input = this.inputs[field];

        if (!input) return;
        input.setAttribute('aria-invalid', 'false');
        input.removeAttribute('aria-describedby');
      });
    }
  }

  customElements.define('sk-gift-form', SiRecipientForm);
}
